import React, { useState } from "react";
import Button from "../../components/CustomButtons/Button";
import { IconButton } from "@material-ui/core";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import TemplateBlockDefault from "./TemplateBlockDefault";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
 

const TemplateBlock = props => {
    const [style, setStyle] = useState('');
    const [content, setContent] = useState('');
    const [blockNum, setBlockNum] = useState(1);
    const { block, editingId, setEditingId, handleContentChange, 
        handleContentChange2, 
        removeBlock, addBlock, moveBlock, duplicateBlock } = props;

    if (block.type === 'Default') {
        // REGULAR 
        return (
            <span
            key={block.id}
            className="group relative bordery rounded p-3 bg-white shadow-sm"
            >
                <TemplateBlockDefault 
                    block={block}
                    editingId={editingId}
                    setEditingId={setEditingId}
                    handleContentChange={handleContentChange}
                    addBlock={addBlock}
                    removeBlock={removeBlock}
                    duplicateBlock={duplicateBlock}
                    moveBlock={moveBlock}
                />
            </span>
        )
    } else if (block.type === '2 Column Table') {
        // 2 columns
        return (
            <span
                key={block.id}
                className="group relative bordery rounded p-3 bg-white shadow-sm"
            >   
                {editingId === block.id && <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                        <Button
                            color="primary"
                            onClick={() => {
                                setBlockNum(1);
                            }}
                        >
                            COLUMN 1
                        </Button>
                        {blockNum === 1 && <TemplateBlockDefault 
                            block={block}
                            editingId={editingId}
                            setEditingId={setEditingId}
                            handleContentChange={handleContentChange}
                            addBlock={addBlock}
                            removeBlock={removeBlock}
                            duplicateBlock={duplicateBlock}
                            moveBlock={moveBlock}
                            column={1}
                        />}
                        {blockNum !== 1 && <span
                                dangerouslySetInnerHTML={{ __html: block.content }}
                            />}
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                        <Button
                            color="primary"
                            onClick={() => {
                                setBlockNum(2);
                            }}
                        >
                            COLUMN 2
                        </Button>
                        {blockNum === 2 && <TemplateBlockDefault 
                            block={block}
                            editingId={editingId}
                            setEditingId={setEditingId}
                            handleContentChange2={handleContentChange2}
                            addBlock={addBlock}
                            removeBlock={removeBlock}
                            duplicateBlock={duplicateBlock}
                            moveBlock={moveBlock}
                            column={2}
                        />}
                        {blockNum !== 2 && <span
                                dangerouslySetInnerHTML={{ __html: block.content2 ? block.content2 : '' }}
                            />}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className="mt-2 flex justify-between">
                            <Button
                                size="sm"
                                color="primary"
                                className="mr-20"
                                onClick={() => setEditingId(null)}
                            >
                            Ok
                            </Button>
                            <Button
                                size="sm"
                                color="white"
                                className="mr-20"
                                onClick={() => {
                                    setEditingId(null)
                                }}
                            >
                            Cancel
                            </Button>
                            <Button
                                size="sm"
                                color="danger"
                                className="mr-20"
                                onClick={() => removeBlock(block.id)}
                            >
                            Delete
                            </Button>
                            <Button
                                size="sm"
                                color="danger"
                                className="mr-20"
                                onClick={() => moveBlock(block.id, 'left')}
                            >
                                <i className="fa fa-arrow-left"></i>
                            </Button>
                            <Button
                                size="sm"
                                color="danger"
                                className="mr-20"
                                onClick={() => moveBlock(block.id, 'right')}
                            >
                                <i className="fa fa-arrow-right"></i>
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>}

                {editingId !== block.id && <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                        <span className="relative bordery" style={{
                            display: 'block',
                            border: '1px solid #ccc',
                            padding: 20
                        }}>
                            <span
                                className="hoverable-gray"
                                onClick={() => setEditingId(block.id)}
                                dangerouslySetInnerHTML={{ __html: block.content }}
                            />
                        </span>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                        <span className="relative bordery" style={{
                            display: 'block',
                            border: '1px solid #ccc',
                            padding: 20
                        }}>
                            <span
                                className="hoverable-gray"
                                onClick={() => setEditingId(block.id)}
                                dangerouslySetInnerHTML={{ __html: block.content2 }}
                            />
                        </span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <span className="relative bordery" style={{
                            display: 'inline-block'
                        }}>
                            <div className="absolute-block">
                                <IconButton
                                    onClick={() => addBlock(block.id)}
                                >
                                    <i className="fa fa-plus-circle text-blue-600" />
                                </IconButton>
                            </div>
                        </span>
                        <span className="relative bordery" style={{
                            display: 'inline-block'
                        }}>
                            <div className="absolute-block">
                                <Button
                                    size="sm"
                                    color="danger"
                                    className="mr-20"
                                    onClick={() => removeBlock(block.id)}
                                >
                                Delete
                                </Button>
                            </div>
                        </span>
                    </GridItem>
                </GridContainer>}
            </span>
        )
    } else if (block.type === 'Logo') {
        // LOGO
        return <div>
            <div className="hoverable-gray">
                <img
                    src="https://illicre.com/wp-content/uploads/2020/04/admin-ajax-3-1-1.png"
                    style={{ width: "80px" }}
                    onClick={() => setEditingId(block.id)}
                />
                {editingId === block.id && <div className="mt-2 flex justify-between">
                    <Button
                        size="sm"
                        color="primary"
                        className="mr-20"
                        onClick={() => setEditingId(null)}
                    >
                    Ok
                    </Button>
                    <Button
                        size="sm"
                        color="white"
                        className="mr-20"
                        onClick={() => removeBlock(block.id)}
                    >
                    Delete
                    </Button>
                    <Button
                        size="sm"
                        color="danger"
                        className="mr-20"
                        onClick={() => moveBlock(block.id, 'left')}
                    >
                        <i className="fa fa-arrow-left"></i>
                    </Button>
                    <Button
                        size="sm"
                        color="danger"
                        className="mr-20"
                        onClick={() => moveBlock(block.id, 'right')}
                    >
                        <i className="fa fa-arrow-right"></i>
                    </Button>
                </div>}
            </div>
        </div>
    } else if (block.type === 'Centered Logo') {
        // LOGO
        return <div>
            <div className="text-center hoverable-gray">
                <img
                    src="https://illicre.com/wp-content/uploads/2020/04/admin-ajax-3-1-1.png"
                    style={{ width: "80px", }}
                    onClick={() => setEditingId(block.id)}
                />
                {editingId === block.id && <div className="mt-2 flex justify-between">
                    <Button
                        size="sm"
                        color="primary"
                        className="mr-20"
                        onClick={() => setEditingId(null)}
                    >
                    Ok
                    </Button>
                    <Button
                        size="sm"
                        color="white"
                        className="mr-20"
                        onClick={() => removeBlock(block.id)}
                    >
                    Delete
                    </Button>
                    <Button
                        size="sm"
                        color="danger"
                        className="mr-20"
                        onClick={() => moveBlock(block.id, 'left')}
                    >
                        <i className="fa fa-arrow-left"></i>
                    </Button>
                    <Button
                        size="sm"
                        color="danger"
                        className="mr-20"
                        onClick={() => moveBlock(block.id, 'right')}
                    >
                        <i className="fa fa-arrow-right"></i>
                    </Button>
                </div>}
            </div>
        </div>
    } else if (block.type === 'Page Break') {
        // PAGE BREAK
        return <div className="text-center hoverable-gray"
            onClick={() => 
                {
                    if (editingId !== block.id) {
                        setEditingId(block.id)}
                    }
            }
        >
            <hr />
            <div
                
            >--- Page Break ---</div>
            <hr />
            {editingId === block.id && <div className="mt-2 flex justify-between">
                <IconButton
                    onClick={() => addBlock(block.id)}
                >
                    <i className="fa fa-plus-circle text-blue-600" />
                </IconButton>
                <Button
                    size="sm"
                    color="primary"
                    className="mr-20"
                    onClick={() => setEditingId(null)}
                >
                Ok
                </Button>
                <Button
                    size="sm"
                    color="white"
                    className="mr-20"
                    onClick={() => removeBlock(block.id)}
                >
                Delete
                </Button>
                <Button
                    size="sm"
                    color="danger"
                    className="mr-20"
                    onClick={() => moveBlock(block.id, 'left')}
                >
                    <i className="fa fa-arrow-left"></i>
                </Button>
                <Button
                    size="sm"
                    color="danger"
                    className="mr-20"
                    onClick={() => moveBlock(block.id, 'right')}
                >
                    <i className="fa fa-arrow-right"></i>
                </Button>
            </div>}

            {editingId !== block.id && (
                <span className="relative bordery" style={block.style ? block.style: {}}>
                    -
                    <div className="absolute-block">
                        <IconButton
                            onClick={() => addBlock(block.id)}
                        >
                            <i className="fa fa-plus-circle text-blue-600" />
                        </IconButton>
                    </div>
                </span>
            )}
        </div>
    } else if (block.type === 'Inline') {
        // INLINE
        return <>
            {editingId === block.id ? (
                <div style={{border:'1px solid #ccc'}}>
                    <input value={block.content} onChange={(e) => {
                        handleContentChange(block.id, e.target.value)
                    }} className="qinline-block" />
                    <div className="mt-2 flex justify-between">
                        <Button
                            size="sm"
                            color="primary"
                            className="mr-20"
                            onClick={() => setEditingId(null)}
                        >
                        Ok
                        </Button>
                        <Button
                            size="sm"
                            color="white"
                            className="mr-20"
                            onClick={() => {
                                setEditingId(null)
                            }}
                        >
                        Cancel
                        </Button>
                        <Button
                            size="sm"
                            color="danger"
                            className="mr-20"
                            onClick={() => removeBlock(block.id)}
                        >
                        Delete
                        </Button>
                        <Button
                            size="sm"
                            color="success"
                            className="mr-20"
                            onClick={() => moveBlock(block.id, 'left')}
                        >
                            <i className="fa fa-arrow-left"></i>
                        </Button>
                        <Button
                            size="sm"
                            color="success"
                            className="mr-20"
                            onClick={() => moveBlock(block.id, 'right')}
                        >
                            <i className="fa fa-arrow-right"></i>
                        </Button>
                    </div>
                </div>
            ) : (
                <span className="relative bordery" style={{
                        display: 'inline-block'
                    }}>
                    <span
                        className="hoverable-gray"
                        onClick={() => setEditingId(block.id)}
                        dangerouslySetInnerHTML={{ __html: block.content }}
                    />
                    <div className="absolute-block">
                        <IconButton
                            onClick={() => addBlock(block.id)}
                        >
                            <i className="fa fa-plus-circle text-blue-600" />
                        </IconButton>
                    </div>
                </span>
            )}
        </>
    } else if (block.type === 'Variable') {
        // INLINE VARIABLE
        return <>
            {editingId === block.id ? (
                <div style={{border:'1px solid #ccc'}}>
                    <div style={{width:500}}>
                        <CustomSelect 
                            options={[
                                '',
                                'Left',
                                'Centered',
                                'Right'
                            ]}
                            default={block.style ? block.style : ''}
                            choose={(chosen) => {
                                setStyle(chosen);
                            }}
                            label="Select Alignment"
                        />
                    </div>
                    <input value={content} onChange={(e) => {
                        setContent(e.target.value);
                    }} className="inline-block" />
                    <div className="mt-2 flex justify-between">
                        <Button
                            size="sm"
                            color="primary"
                            className="mr-20"
                            onClick={() => {
                                let divLeft = '';
                                let divRight = '';
                                if (style === 'Centered') {
                                    divLeft = '<div style="text-align:center">';
                                    divRight = '</div>';
                                } else if (style === 'Right') {
                                    divLeft = '<div style="text-align:right">';
                                    divRight = '</div>';
                                }
                                handleContentChange(block.id, `${divLeft}${content}${divRight}`, style)
                                setEditingId(null)
                                setStyle('');
                            }}
                        >
                        Ok
                        </Button>
                        <Button
                            size="sm"
                            color="white"
                            className="mr-20"
                            onClick={() => {
                                setEditingId(null)
                            }}
                        >
                        Cancel
                        </Button>
                        <Button
                            size="sm"
                            color="danger"
                            className="mr-20"
                            onClick={() => removeBlock(block.id)}
                        >
                        Delete
                        </Button>
                        <Button
                            size="sm"
                            color="success"
                            className="mr-20"
                            onClick={() => moveBlock(block.id, 'left')}
                        >
                            <i className="fa fa-arrow-left"></i>
                        </Button>
                        <Button
                            size="sm"
                            color="success"
                            className="mr-20"
                            onClick={() => moveBlock(block.id, 'right')}
                        >
                            <i className="fa fa-arrow-right"></i>
                        </Button>
                    </div>
                </div>
            ) : (
                <span className="relative bordery" style={{
                        color: 'green',
                        display: block.style !== 'Left' ? 'block' : 'inline-block',
                        textAlign: block.style === 'Centered' ? 'center' : 
                            block.style === 'Right' ? 'right' : 'left'
                    }}>
                    <span
                        className="hoverable-gray"
                        onClick={() => {
                            setEditingId(block.id);
                            setStyle(block.style ? block.style : '');
                            setContent(block.content ? block.content : '');
                        }}
                        dangerouslySetInnerHTML={{ __html: block.content }}
                    />
                    <div className="absolute-block">
                        <IconButton
                            onClick={() => addBlock(block.id)}
                        >
                            <i className="fa fa-plus-circle text-blue-600" />
                        </IconButton>
                    </div>
                </span>
            )}
        </>
    }

    return <>

    </>
}

export default TemplateBlock;